import type { ReactElement } from 'react'

import Content from '../../templateComponents/Workspace/Workspace'

export default function Page(): ReactElement {
  return (
    <div className="editorial">
      <div className="section-dali">
        <Content />
      </div>
    </div>
  )
}
